<template>
  <v-row dense class="mx-0">
    <v-col v-for="card in visibleCards" :key="card.key" cols="12" sm="6" md lg>
      <v-card class="pa-4" elevation="0" rounded="lg" height="100%">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-flex align-center gap-3">
              <v-avatar :color="card.color" size="36">
                <v-icon size="20" dark>{{ card.icon }}</v-icon>
              </v-avatar>
              <div>
                <h5 class="font-weight-bold mb-0">
                  <v-skeleton-loader
                    v-if="loading"
                    width="80"
                    height="22"
                    type="card"
                  />
                  <span v-else>{{ card.display }}</span>
                </h5>
                <p class="mb-0 text-caption">{{ card.name }}</p>
                <p
                  v-if="card.subtitle && !loading"
                  class="mb-0 text-caption text--secondary"
                >
                  {{ card.subtitle }}
                </p>
              </div>
            </div>
          </template>
          <span>{{ card.description }}</span>
        </v-tooltip>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardKpis",
  props: {
    kpis: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    permissions: { type: Object, required: true },
  },
  computed: {
    visibleCards() {
      const cards = [];

      if (this.permissions.financial) {
        cards.push({
          key: "ticketRevenue",
          name: "Valor Ingressos",
          display: this.$options.filters.currency(
            this.kpis?.revenue?.ticket || 0
          ),
          color: "blue lighten-2",
          icon: "mdi-ticket",
          description: "Faturamento bruto de ingressos no período filtrado.",
        });

        cards.push({
          key: "barRevenue",
          name: "Valor Bar",
          display: this.$options.filters.currency(this.kpis?.revenue?.bar || 0),
          color: "purple lighten-2",
          icon: "mdi-glass-cocktail",
          description: "Faturamento bruto do bar no período filtrado.",
        });

        cards.push({
          key: "totalRevenue",
          name: "Faturamento Total",
          display: this.$options.filters.currency(
            this.kpis?.revenue?.total || 0
          ),
          color: "green lighten-2",
          icon: "mdi-cash-multiple",
          description: "Soma bruta de ingressos e bar no período filtrado.",
        });
      }

      if (this.permissions.events) {
        cards.push({
          key: "tickets",
          name: "Ingressos Emitidos",
          display: this.$options.filters.number(this.kpis?.ticketsIssued || 0),
          color: "blue lighten-2",
          icon: "mdi-ticket-confirmation",
          description: "Quantidade total de ingressos gerados no período.",
        });
      }

      if (this.permissions.events) {
        cards.push({
          key: "bar",
          name: "Fichas de Bar",
          display: this.$options.filters.number(this.kpis?.barTokens || 0),
          color: "purple lighten-2",
          icon: "mdi-glass-cocktail",
          description: "Quantidade total de fichas emitidas no bar no período.",
        });
      }

      return cards;
    },
  },
};
</script>
